module.exports = __webpack_public_path__ + "static/media/Artboard1.b16e4609.png";